export const accentMap = {
  blue: { bg: "#e0ecff", fg: "#1d4ed8" },
  violet: { bg: "#ebe9ff", fg: "#6d28d9" },
  green: { bg: "#e5f8f2", fg: "#0f766e" },
  amber: { bg: "#fff4e0", fg: "#c2410c" },
  aqua: { bg: "#e0f7ff", fg: "#0ea5e9" },
  coral: { bg: "#ffe7e2", fg: "#dc2626" },
};

export const formatNumber = (value, isMoney = false) => {
  if (value === null || value === undefined) return isMoney ? "$0" : "0";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  const formatted = num.toLocaleString("es-EC");
  return isMoney ? `$${formatted}` : formatted;
};

const dayLabel = (dia, fallbackIndex = 0) => {
  const names = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];
  const d = dia ? new Date(dia) : null;
  if (d && !Number.isNaN(d.getTime())) {
    return names[d.getDay()];
  }
  return names[fallbackIndex % names.length];
};

export const formatShortDate = (dia, fallbackIndex = 0) => {
  const d = dia ? new Date(dia) : null;
  if (d && !Number.isNaN(d.getTime())) {
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}`;
  }
  return dayLabel(dia, fallbackIndex);
};

const monthLabels = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const toMonthLabel = (value) => {
  const idx = Number(value) - 1;
  return monthLabels[idx] || value;
};
